
/**
 * call_back_button_auth_pressed
 * Нажатие на кнопку "Назад" на экране "Подтвердите номер телефона по звонку"
 */
export interface CallBackButtonAuthPressed {}

export function mapCallBackButtonAuthPressedEvent(event: CallBackButtonAuthPressed): object {
  const props: Record<string, unknown> = {
  };

  return {
    event: 'analytics_event',
    event_name: 'call_back_button_auth_pressed',
    event_properties: {},
  };
}
